import { createUseDocumentTitleHook } from '@cmg/common';

/**
 * Singleton of useDocumentTitle for xc-client-web, created from hook factory function
 */
export const useDocumentTitle = createUseDocumentTitleHook('CMG XC');
